import {DomCommand, DomCommandDataMap} from "./DomManipulation";

export interface AjaxResp<K extends keyof KnownActionData> {
    fragmentActions: FragmentAction<K>[];
    fragmentCalls: {
        method: string,
        actions: FragmentAction<K>[],
    }[];
}

export interface FragmentAction<K extends keyof KnownActionData>{
    type: K,
    data: KnownActionData[K]
}

export interface KnownActionData {
    rfv: ReplaceFragmentViewActionData,
    rf: ReplaceFragmentActionData,
    openModal: OpenModalActionData,
    dom: DomSelectorManipulationActionData,
    event: EventActionData,
    uievent: UiEventActionData,
    redirect: RedirectActionData,
    openBlank: OpenBlankActionData,
    props: UpdatePropsActionData
}

/**
 * Aktualizacja properties we fragmencie
 */
interface UpdatePropsActionData {
    p: string
}

interface RedirectActionData {
    url: string
}

interface OpenBlankActionData {
    url: string
}

interface DomSelectorManipulationActionData {
    tag?: string;
    selector: string;
    commands: Array<DomCommand<keyof DomCommandDataMap>>;
}

interface OpenModalActionData {
    //selector elementu do wstawienia modala
    target?: string;

    //kod html modala
    html: string;

}

interface ReplaceFragmentViewActionData {
    html: string
}

interface ReplaceFragmentActionData {
    html: string
}

interface UiEventActionData {
    e: string
}

interface EventActionData {
    e: string,
    tag: string,
    param: string,
}

type Call<K extends keyof KnownActionData> = ((e: HTMLElement, data: KnownActionData[K]) => void)

type ActionCallbacks = {
    [K in keyof KnownActionData]: Call<K>
};

export class Events {

    public static OPEN_MODAL_EVENT = "eventOpenModal";
    public static DOM_EVENT = "eventDOM";
    public static REPLACE_FRAGMENT_EVENT = "eventReplaceFragment";
    public static REPLACE_FRAGMENT_VIEW_EVENT = "eventReplaceFragmentView";
    public static EVENT = "eventEvent";
    public static UIEVENT = "eventUiEvent";
    public static REDIRECT = "eventRedirect";
    public static OPEN_BLANK = "eventOpenBlank";
    public static UPDATE_PROPS = "eventUpdateProps";

    private static callbacks: ActionCallbacks = {
        props(e:HTMLElement, data:KnownActionData["props"]): void {
            e.dispatchEvent(new CustomEvent<UpdatePropsActionData>(Events.UPDATE_PROPS, {
                detail: data
            }))
        },

        redirect(e:HTMLElement, data:KnownActionData["redirect"]): void {
            e.dispatchEvent(new CustomEvent<RedirectActionData>(Events.REDIRECT, {
                detail: data
            }))
        },

        openBlank(e:HTMLElement, data:KnownActionData["openBlank"]): void {
            e.dispatchEvent(new CustomEvent<RedirectActionData>(Events.OPEN_BLANK, {
                detail: data
            }))
        },

        dom(e: HTMLElement, data: KnownActionData["dom"]): void {
            e.dispatchEvent(new CustomEvent<DomSelectorManipulationActionData>(Events.DOM_EVENT, {
                detail: data
            }))
        },

        openModal(e: HTMLElement, data: KnownActionData["openModal"]): void {
            e.dispatchEvent(new CustomEvent<OpenModalActionData>(Events.OPEN_MODAL_EVENT, {
                detail: data
            }))
        },

        rf(e: HTMLElement, data: KnownActionData["rf"]): void {
            e.dispatchEvent(new CustomEvent<ReplaceFragmentActionData>(Events.REPLACE_FRAGMENT_EVENT, {
                detail: data
            }));
        },

        rfv(e: HTMLElement, data: KnownActionData["rfv"]): void {
            e.dispatchEvent(new CustomEvent<ReplaceFragmentActionData>(Events.REPLACE_FRAGMENT_VIEW_EVENT, {
                detail: data
            }));
        },

        event(e:HTMLElement, data: KnownActionData["event"]):void {
            e.dispatchEvent(new CustomEvent<EventActionData>(Events.EVENT, {
                detail: data
            }));
        },

        uievent(e:HTMLElement, data: KnownActionData["uievent"]):void {
            e.dispatchEvent(new CustomEvent<UiEventActionData>(Events.UIEVENT, {
                detail: data
            }));
        }
    };



    public static addEventListeners(
        element: HTMLElement,
        openModalHandler: ((e: CustomEvent<KnownActionData["openModal"]>) => void),
        domModHandler: ((e: CustomEvent<KnownActionData["dom"]>) => void),
        replaceFragmentView: ((e: CustomEvent<KnownActionData["rfv"]>) => void),
        replaceFragment: ((e: CustomEvent<KnownActionData["rf"]>) => void),
        event: ((e: CustomEvent<KnownActionData["event"]>) => void),
        uievent: ((e: CustomEvent<KnownActionData["uievent"]>) => void),
        updateProps: ((e: CustomEvent<KnownActionData["props"]>) => void),
    ){

        element.addEventListener(Events.OPEN_MODAL_EVENT, openModalHandler);
        element.addEventListener(Events.DOM_EVENT, domModHandler);
        element.addEventListener(Events.REPLACE_FRAGMENT_VIEW_EVENT, replaceFragmentView);
        element.addEventListener(Events.EVENT, event);
        element.addEventListener(Events.UIEVENT, uievent);
        element.addEventListener(Events.REPLACE_FRAGMENT_EVENT, replaceFragment);
        element.addEventListener(Events.UPDATE_PROPS, updateProps);

        element.addEventListener(Events.REDIRECT, (e: CustomEvent<KnownActionData["redirect"]>) => {
            window.location.href = e.detail.url;
        });

        element.addEventListener(Events.OPEN_BLANK, (e: CustomEvent<KnownActionData["openBlank"]>) => {
            window.open(e.detail.url, "_blank");
        });

    }

    public static dispatch<K extends keyof KnownActionData>(e: HTMLElement, type: K, data: KnownActionData[K]): void {
        let d = this.callbacks[type];
        (d as Call<K>)(e, data);
    }

}